import { apiService } from '../APIService';
import { CRUDFactory } from '../CRUDFactory';

export const CRUDTasks = CRUDFactory('tasks');

export default {
  doneTask(id) {
    return apiService.post(`/tasks/${id}/done`);
  },
  attachUser(id, users_id) {
    return apiService.post(`/tasks/${id}/attach-user`, { user_ids: users_id });
  },
  detachUser(id, users_id) {
    return apiService.post(`/tasks/${id}/detach-user`, { user_ids: users_id });
  },
  pivotUpdate(id, is_favorite, comment) {
    return apiService.post(`/tasks/${id}/pivot-update`, { is_favorite, comment });
  },
  onCheck(id, text) {
    return apiService.post(`/tasks/${id}/on-check`, { text });
  },
  manipulateFiles(id, params) {
    return apiService.put(`/tasks/${id}`, params);
  },
};
